export default {
  employees: 'ADMIN_EMPLOYEES_DETAIL',
  field: 'ADMIN_EMPLOYEES_FIELD'
};
